<div class="symbol-group flex-col gap-5" [formGroup]="symbolsFormGroup">
  @for (activityType of (activityTypes$ | async); track activityType) {
    @if (getSymbolsGroupForId(activityType.id); as section) {
      <div mat-subheader>
        {{ activityType.id === 0 ? (activityType.name | translate) : activityType.name }}
      </div>
      <mat-list cdkDropList [cdkDropListData]="section" (cdkDropListDropped)="dropSymbol($event, activityType.id.toString())" class="symbol-list">
        @for (controlForm of section.controls | keyvalue: orderSectionControls; track controlForm) {
          <form class="symbol-form" [formGroup]="controlForm.value">
            <div class="symbol-list-item" cdkDrag>
              <ng-container [ngTemplateOutlet]="symbolDetail" [ngTemplateOutletContext]="{ controlForm }"></ng-container>
              <button (click)="toggleEditSymbol(controlForm.value?.get('id')?.value)" mat-icon-button color="secondary" type="button">
                @if (editSymbolId !== controlForm.value?.get('id')?.value) {
                  <mat-icon class="mat-24">edit</mat-icon>
                }
                @if (editSymbolId === controlForm.value?.get('id')?.value) {
                  <mat-icon class="mat-24">close</mat-icon>
                }
              </button>
              <div *cdkDragPreview>
                <ng-container [ngTemplateOutlet]="symbolDetail" [ngTemplateOutletContext]="{ controlForm }"></ng-container>
              </div>
            </div>
            @if (editSymbolId === controlForm.value?.get('id')?.value) {
              <ng-container [ngTemplateOutlet]="editSymbol" [ngTemplateOutletContext]="{ controlForm }"></ng-container>
            }
          </form>
        }
      </mat-list>
    }
  }
</div>
<button mat-fab class="doenkids-fab" color="primary" (click)="addSymbol()">
  <mat-icon [attr.aria-label]="'customer_symbols.add.label' | translate">add</mat-icon>
</button>

<ng-template #symbolDetail let-controlForm="controlForm" let-sectionKey="sectionKey">
  <div class="symbol-details">
    <app-doenkids-image class="image draggable" [maxWidth]="42" [maxHeight]="42" [mediaItem]="controlForm.value?.get('media_uuid')?.value"></app-doenkids-image>
    <div class="flex-row">
      {{ controlForm.value?.get('name')?.value }}
      <div class="symbol-conditions-inline">
        @for (id of controlForm.value?.get('condition')?.value?.activity_kind; track id) {
          <span>{{getListItemDescription(id, conditions?.activity_kind)}}</span>
        }
        @for (id of controlForm.value?.get('condition')?.value?.age_group; track id) {
          <span>{{getListItemDescription(id, conditions?.age_group)}}</span>
        }
        @for (id of controlForm.value?.get('condition')?.value?.area_of_development; track id) {
          <span>{{getListItemDescription(id, conditions?.area_of_development)}}</span>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template #editSymbol let-controlForm="controlForm">
  <div class="flex-row" [formGroup]="controlForm.value">
    <app-asset-upload class="image" [identifier]="'symbol-image-'+ controlForm.value?.get('id')?.value" purpose="symbol" (uploaded)="addSymbolImage($event, controlForm.value)">
      <ng-template let-uploadData="uploadData" let-fileInput="fileInput">
        <div class="image-container">
          <app-doenkids-image class="image" [maxWidth]="100" [maxHeight]="100" [mediaItem]="controlForm.value?.get('media_uuid')?.value"></app-doenkids-image>
        </div>
        <app-select-media [identifier]="'symbol-image-'+ controlForm.value?.get('id')?.value" [uploadData]="uploadData" purpose="symbol" (selected)="addSymbolImage($event, controlForm?.value)"></app-select-media>
      </ng-template>
    </app-asset-upload>
    <div class="flex-col symbol-form-group">
      <div class="flex-row gap-5 side-by-side">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'customer_symbol.name.label' |translate }}</mat-label>
          <input formControlName="name" matInput>
          @if (controlForm.value?.get('name')?.invalid) {
            <mat-error>
              {{ 'generic.form.required_field' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'customer_symbol.activity_type.label' | translate }}</mat-label>
          <mat-select formControlName="activity_type_id" required>
            @for (type of activityTypes$ | async; track type) {
              <mat-option [value]="type.id">
                {{ type.id === 0 ? (type.name | translate) : type.name }}
              </mat-option>
            }
          </mat-select>
          @if (controlForm.value?.get('activity_type_id')?.invalid) {
            <mat-error>
              {{ 'generic.form.required_field' | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <!-- BEGIN ACTIVITY KIND -->
      @if (conditions?.activity_kind) {
        <mat-form-field class="symbol-condition activity-kind">
          <mat-label>{{ 'activity.labels.activity_kind' | translate }}</mat-label>
          <mat-chip-grid
            #activityKindList
            [attr.aria-label]="'activity.labels.activity_kind' | translate">
            @for (id of controlForm.value?.get('condition')?.value?.activity_kind; track id) {
              <mat-chip-row
                (removed)="removeCondition(controlForm.value?.get('condition'), 'activity_kind', id)"
                [removable]="true">
                {{getListItemDescription(id, conditions.activity_kind)}}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
            }
            <input
              [placeholder]="'customer_symbols.activity_kind.add.placeholder' | translate"
              #activityKindInput
              [matAutocomplete]="activityKindAutocomplete"
              [matChipInputFor]="activityKindList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              >
          </mat-chip-grid>
          <mat-autocomplete #activityKindAutocomplete="matAutocomplete" (optionSelected)="addCondition(controlForm.value?.get('condition'), 'activity_kind', $event)">
            @for (item of conditions.activity_kind; track item) {
              <mat-option [value]="item">
                {{item.name}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }
      <!-- END ACTIVITY KIND -->
      <!-- BEGIN AGE GROUP -->
      @if (conditions?.age_group) {
        <mat-form-field class="symbol-condition age-group">
          <mat-label>{{ 'activity.labels.age_group' | translate }}</mat-label>
          <mat-chip-grid
            #ageGroupList
            [attr.aria-label]="'customer_symbol.age_group.label' | translate">
            @for (id of controlForm.value?.get('condition')?.value?.age_group; track id) {
              <mat-chip-row
                (removed)="removeCondition(controlForm.value?.get('condition'), 'age_group', id)"
                [removable]="true">
                {{getListItemDescription(id, conditions.age_group)}}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
            }
            <input
              [placeholder]="'customer_symbol.age_group.add.placeholder' | translate"
              #ageGroupInput
              [matAutocomplete]="ageGroupAutocomplete"
              [matChipInputFor]="ageGroupList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              >
          </mat-chip-grid>
          <mat-autocomplete #ageGroupAutocomplete="matAutocomplete" (optionSelected)="addCondition(controlForm.value?.get('condition'), 'age_group', $event)">
            @for (item of conditions.age_group; track item) {
              <mat-option [value]="item">
                {{item.name}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }
      <!-- END ACTIVITY KIND -->
      <!-- BEGIN AREA OF DEVELOPMENT -->
      @if (conditions?.area_of_development) {
        <mat-form-field class="symbol-condition area-of-development">
          <mat-label>{{ 'activity.labels.area_of_development' | translate }}</mat-label>
          <mat-chip-grid
            #areaOfDevelopmentList
            [attr.aria-label]="'customer_symbol.area_of_development.label' | translate">
            @for (id of controlForm.value?.get('condition')?.value?.area_of_development; track id) {
              <mat-chip-row
                (removed)="removeCondition(controlForm.value?.get('condition'), 'area_of_development', id)"
                [removable]="true"
                >
                {{getListItemDescription(id, conditions.area_of_development)}}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
            }
            <input
              [placeholder]="'customer_symbol.area_of_development.add.placeholder' | translate"
              #areaOfDevelopmentInput
              [matAutocomplete]="areaOfDevelopmentAutocomplete"
              [matChipInputFor]="areaOfDevelopmentList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              />
          </mat-chip-grid>
          <mat-autocomplete #areaOfDevelopmentAutocomplete="matAutocomplete" (optionSelected)="addCondition(controlForm.value?.get('condition'), 'area_of_development', $event)">
            @for (item of conditions.area_of_development; track item) {
              <mat-option [value]="item">
                {{item.name}}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }
      <!-- END AREA OF DEVELOPMENT  -->
      <div class="flex-row justify-end items-center">
        <div class="flex-row action-buttons justify-end items-center gap-4">
          <button color="secondary" mat-button type="button" (click)="removeSymbol(controlForm.value?.get('id')?.value)">
            {{ 'generic.remove' | translate | uppercase }}
          </button>
          <button color="primary" mat-button type="button" (click)="saveSymbol(controlForm.value)">
            {{ 'generic.save' | translate | uppercase }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

